/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Fiscal Year Start Month
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type FiscalYearStartMonthEnum = 'January' | 'April' | 'July' | 'October';

export const FiscalYearStartMonthEnum = {
    January: 'January' as FiscalYearStartMonthEnum,
    April: 'April' as FiscalYearStartMonthEnum,
    July: 'July' as FiscalYearStartMonthEnum,
    October: 'October' as FiscalYearStartMonthEnum
};

marker('January');
marker('April');
marker('July');
marker('October');

